<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content h-100">
      <div class="modal-header">
        <h5 class="modal-title">Reassign Leads</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <div class="modal-body">
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">From Telemarketer <span class="text-danger">*</span></label>
          <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" [ngClass]="{'disabled-select': this.data?.leadID !== undefined }" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'fromTelemarketerDropdownList'
              [dropdownSettings] = 'fromTelemarketerDropdownSettings'
              [formName] = "'telemarketer_id'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'fromTelemarketerSelectedItems'
              (selectedItemsChanged)="onSelectFromTelemarketer($event)">
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
        <div class="col-12 row form-group pr-0" [ngClass]="{'mb-0': invalidDateRange }">
          <label class="col-12 col-form-label sub_tab_title">Lead Filter</label>
          <label class="col-4 col-form-label">Lead Assigned Date <span class="text-danger">*</span>&nbsp;<i class="fa fa-info-circle ml-1" placement="right" [ngbTooltip]="linkToolTip1" tooltipClass="tooltip-class custom-tooltip"></i></label>
          <ng-template #linkToolTip1>
            <div class="text-left">
              Lead assigned date range of selection must be within <b>31 day(s)</b> only.
            </div>
          </ng-template>
          <div class="col-8 p-0" [ngClass]="{'div-disabled-date': this.data?.leadID !== undefined }">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Please select"
                  (change)="onDateRange($event)" formControlName="defaultDate"
                  [timePicker]="true" [timePickerSeconds]="true"
                  [alwaysShowCalendars]="true" [ranges]="ranges"
                  [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale"
                  [timePicker24Hour]="true" [showDropdowns]="true" (click)="updateDateRange()"
                  ngxDaterangepickerMd/>
              <span class="input-group-append" *ngIf="this.data?.leadID == undefined">
                  <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
              </span>
            </div>
          </div>
        </div>
        <ng-container *ngIf="invalidDateRange">
          <div class="col-12 row form-group p-0 m-0">
            <label class="col-4 col-form-label"></label>
            <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
              <span class="text-danger" style="font-weight: 500;">Date range is exceed 31 days.</span>
            </div>
          </div>
        </ng-container>
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">Current Lead Status <span class="text-danger">*</span></label>
          <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" [ngClass]="{'disabled-select': this.data?.leadID !== undefined }" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'statuesDropdownList'
              [dropdownSettings] = 'statuesDropdownSettings'
              [formName] = "'lead_status'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'statuesSelectedItems'
              (selectedItemsChanged)="onSelectLeadStatus($event)">
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
        <hr>
        <div class="col-12 row form-group pr-0" style="margin-top: 2rem;">
          <label class="col-4 col-form-label">To Telemarketer <span class="text-danger">*</span></label>
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'toTelemarketerDropdownList'
              [dropdownSettings] = 'toTelemarketerDropdownSettings'
              [formName] = "'to_telemarketer_id'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'toTelemarketerSelectedItems'
              (selectedItemsChanged)="onSelectToTelemarketer($event)">
            </kt-dropdown-wo-lazyload>
        </div>
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">Leads <span class="text-danger">*</span></label>
          <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'leadsDropdownList'
              [dropdownSettings] = 'leadsDropdownSettings'
              [formName] = "'lead_ids'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'leadsSelectedItems'>
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">Status <span class="text-danger">*&nbsp;</span>
            <i class="fa fa-info-circle ml-1" placement="bottom" [ngbTooltip]="linkToolTip" tooltipClass="tooltip-class"></i>
          </label>
          <select class="form-control col-8" *ngIf="dropdown.lead_statuses" formControlName="status" [ngClass]="{'is-invalid': checkValidation && form.controls.status.errors }">
            <option *ngFor="let value of dropdown.lead_statuses; let i = index;" [value]="i">{{ value }}</option>
          </select>
        </div>
        <ng-template #linkToolTip>
          <div class="text-left">
            <b>Active:</b> Leads will be set to "Active" status and assigned to the new telemarketer. The accumulated deposit amount will be reset to 0, and the validity period will restart from the reassignment date and time. <br>
            <b>Closed:</b> Applicable only leads with total lifetime deposit more than target amount. Leads will be "Closed" status and reassigned to the new telemarketer.
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        <button class="btn btn-primary btn-icon-sm mr-2" (click)="data?.leadID === undefined ? onSubmit() : onConfirmation()" type="button" [disabled]="buttonLoading || !form.valid || fromTelemarketerSelectedItems.length == 0"><i [class]="buttonLoading? 'fas fa-circle-notch fa-spin p-0 mr-2' : 'fas fa-save'"></i>{{ 'Submit' }}</button>
      </div>
    </div>
  </form>
</div>
<kt-swal-alert [message]="messages1$ | async" [data]="data1$ | async" (confirmed)="onSubmit(true)"></kt-swal-alert>